import styled from 'styled-components';
import Button from '@material-ui/core/Button';

export default styled(Button)`
  margin: 0 12px 12px auto;
  width: 40%;
  background-color: white;
  font-weight: bold;
`;
